export default __webpack_public_path__ + "static/media/KZ.M.20.2157.f4ab58b7.svg";